// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const Preloader = ((($) => {

  function init() {
    // setTimeout(function() {
    //   $(this);
    //   $('.Preloader').fadeOut('fast');
    // }, 1000);
    setTimeout(function() {
      $(this);
      addClassBlock($('.Preloader_logo'), 'animated');
    }, 1000);
    setTimeout(function() {
      $(this);
      addClassBlock($('.Preloader'), 'animated');
    }, 1500);
    setTimeout(function() {
      $(this);
      addClassBlock($('.Hero'), 'animated');
    }, 2000);
    setTimeout(function() {
      $(this);
      show_popup();
    },2300);
  }

  function show_popup() {
    $('#sold-popup-link').trigger('click');
  }

  function addClassBlock(currentBlock, clas) {
    currentBlock.addClass(clas);
  }

  return {
    init,
  };
}))(jQuery);

export default Preloader;



// WEBPACK FOOTER //
// ./src/static/js/modules/preloader.js